import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FormatUtils from 'utils/format';

const Price = ({
    className,
    amount,
    currencyType,
    showCents,
    hideSupElement,
}) => {
    const classes = classNames('Price', className);
    const currencySymbol = FormatUtils.currencySymbol(currencyType);
    const {dollars, cents, displayPrice} = FormatUtils.price(amount);
    const displayCents = showCents && !cents ? '00' : cents;
    const centElement = hideSupElement ? (
        `.${displayCents}`
    ) : (
        <sup>.{displayCents}</sup>
    );

    return (
        <span className={classes}>
            {currencySymbol}
            {dollars}
            {displayCents ? centElement : ''}
            <meta itemProp="price" content={displayPrice} />
            <meta itemProp="priceCurrency" content={currencyType} />
        </span>
    );
};

Price.propTypes = {
    className: PropTypes.string,
    amount: PropTypes.number.isRequired,
    currencyType: PropTypes.string,
    showCents: PropTypes.bool,
    hideSupElement: PropTypes.bool,
};

export default Price;
